__turbopack_context__.v({
  "card": "ArticleGrid-module-scss-module__lz1mJa__card",
  "list": "ArticleGrid-module-scss-module__lz1mJa__list",
  "list-item": "ArticleGrid-module-scss-module__lz1mJa__list-item",
  "pdf": "ArticleGrid-module-scss-module__lz1mJa__pdf",
});
